import App from 'app/app.js';

function LtEqualityValidationDirective() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      var validate = function (value, other) {
        var valid;
        valid = !other || value === other;
        if (attrs.ltEqualToIgnoreCase === 'true' && value) {
          valid = !other || value.toUpperCase() === other.toUpperCase();
        }
        ctrl.$setValidity('ltEqualTo', valid);
        return valid;
      };

      var unwatch = scope.$watch(attrs.ltEqualTo, function (value) {
        validate(ctrl.$viewValue, value);
      });

      ctrl.$parsers.push(function (value) {
        return validate(value, scope.$eval(attrs.ltEqualTo)) ? value : undefined;
      });

      scope.$on('$destroy', function () {
        unwatch();
      });
    }
  };
}

App.directive('ltEqualTo', [LtEqualityValidationDirective]);
